import { useParams } from 'react-router-dom';

interface KnownParams {
	dealId: string;
	mipId: string;
	fundId: string;
	investorId: string;
	personId: string;
	investmentId: string;
	investmentWorkflowId: string;
	documentWorkflowInstanceId: string;
	documentId: string;
	bankAccountId: string;
	messageId: string;
}

export function useRequiredParams<K extends keyof KnownParams>(...keys: K[]): Pick<KnownParams, K> {
	const params = useParams();

	const missingKeys = keys.filter((key) => !params[key as string]);

	if (missingKeys.length > 0) {
		throw new Error(`Missing required route params: ${missingKeys.join(', ')}`);
	}

	return params as Pick<KnownParams, K>;
}
